import { Record } from 'immutable';
const ImportProgress = Record({
  autoPublishEnabled: false,
  baseUrl: undefined,
  cancelled: false,
  error: undefined,
  finishedAt: undefined,
  hasCancelledImporting: false,
  hasSuccessfullyCompletedImporting: false,
  importedArticleCount: 0,
  isImporting: false,
  isPollingActive: false,
  isPostProcessing: false,
  isRequesting: false,
  isScraping: false,
  lastLoaded: undefined,
  locked: false,
  lockedUntil: undefined,
  postProcessedArticleCount: 0,
  skippedArticleCount: 0,
  startedAt: undefined,
  totalArticleCount: 0,
  importId: 0,
  knowledgeBaseId: 0
});
export default ImportProgress;